
import {PosManagerRepository} from "@/modules/posManager/adapter/PosManagerRepository";

export class PosManagerPort implements PosManagerRepository{
    public async sendArticle(mode: number): Promise<string> {
        return this.posManagerRepository.sendArticle(mode);
    }

    public async sendMCustomers(mode: number): Promise<string> {
        return this.posManagerRepository.sendMCustomers(mode);
    }
    public async receiveTaf(): Promise<string> {
        return this.posManagerRepository.receiveTaf();
    }

    public async receiveFinancialReports(): Promise<string> {
        return this.posManagerRepository.receiveFinancialReports();
    }

    public async get_task_status(tasks:any[]):Promise<any[]> {
        return this.posManagerRepository.get_task_status(tasks);
    }
    public async start_Bestandsaktualisierung(): Promise<string> {
        return this.posManagerRepository.start_Bestandsaktualisierung();
    }
    public async receivePersonalzeiten(): Promise<string> {
        return this.posManagerRepository.receivePersonalzeiten();
    }

    public async bestandsmeldungen_process_Scandata(code:string, method:number, auftrag:number):Promise<any> {
        return this.posManagerRepository.bestandsmeldungen_process_Scandata(code, method, auftrag);
    }

    public async sendMasterdata(mode: number): Promise<string> {
        return this.posManagerRepository.sendMasterdata(mode);
    }

    public async sendScaleData(mode: number): Promise<string> {
        return this.posManagerRepository.sendScaleData(mode);
    }
    private readonly posManagerRepository: PosManagerRepository;

    constructor(params: { posManagerRepository: PosManagerRepository }) {
        this.posManagerRepository = params.posManagerRepository;
    }
    public async getConnectionStatus():Promise<number> {
        return this.posManagerRepository.getConnectionStatus();
    }
    public async isTransmitting():Promise<boolean> {
        return this.posManagerRepository.isTransmitting();
    }

    public async getReports(reportTyp:number) : Promise<any[]> {
        return this.posManagerRepository.getReports(reportTyp);
    }

    public async getReport(args:{reportNr:number, start:Date, end:Date}): Promise<string> {
        return this.posManagerRepository.getReport(args);
    }

    public async getCashReport(date:string, id:number): Promise<string> {
        return this.posManagerRepository.getCashReport(date,id);
    }

    public async getBonReport(id:number): Promise<string> {
        return this.posManagerRepository.getBonReport(id);
    }

    public async sendArticleList(selected:{RecordId:number}[]): Promise<string> {
        return this.posManagerRepository.sendArticleList(selected);
    }

    public getSalesGridList(): any[] {
        return this.posManagerRepository.getSalesGridList();
    }


}
